import { BlogArticle } from "@/app/types/BlogArticle";
import { BlogArticleLocale } from "@/app/types/BlogArticleContent";
import { avatarValidationArticle } from "../../content/AvatarValidationArticle";
import { avatarWithoutClientsArticle } from "../../content/AvatarWithoutClientsArticle";
import { buyingSignalsArticle } from "../../content/BuyingSignalsArticle";
import { callRecordingGdprArticle } from "../../content/CallRecordingGdprArticle";
import { callToolsArticle } from "../../content/CallToolsArticle";
import { clientAvatarArticle } from "../../content/ClientAvatarArticle";
import { demoCallArticle } from "../../content/DemoCallArticle";
import { discoveryCallArticle } from "../../content/DiscoveryCallArticle";
import { followUpSequenceArticle } from "../../content/FollowUpSequenceArticle";
import { freeCallAnalysisArticle } from "../../content/FreeCallAnalysisArticle";
import { leexiPricingArticle } from "../../content/LeexiPricingArticle";
import { linkedinLimitsArticle } from "../../content/LinkedinLimitsArticle";
import { linkedinMessageArticle } from "../../content/LinkedinMessageArticle";
import { modjoAlternativesArticle } from "../../content/ModjoAlternativesArticle";
import { networkQualificationArticle } from "../../content/NetworkQualificationArticle";
import { offerBuildArticle } from "../../content/OfferBuildArticle";
import { offerNotSellingArticle } from "../../content/OfferNotSellingArticle";
import { offerPricingArticle } from "../../content/OfferPricingArticle";
import { prospectListsArticle } from "../../content/ProspectListsArticle";
import { realtimeAnalysisArticle } from "../../content/RealtimeAnalysisArticle";
import { replyToMeetingArticle } from "../../content/ReplyToMeetingArticle";
import { salesNavigatorArticle } from "../../content/SalesNavigatorArticle";
import { situationTargetingArticle } from "../../content/SituationTargetingArticle";
import { smallTeamCallAnalysisArticle } from "../../content/SmallTeamCallAnalysisArticle";

export const BLOG_ARTICLES: BlogArticle[] = [
  prospectListsArticle,
  demoCallArticle,
  realtimeAnalysisArticle,
  networkQualificationArticle,
  callRecordingGdprArticle,
  smallTeamCallAnalysisArticle,
  discoveryCallArticle,
  linkedinLimitsArticle,
  followUpSequenceArticle,
  offerNotSellingArticle,
  avatarValidationArticle,
  offerPricingArticle,
  avatarWithoutClientsArticle,
  replyToMeetingArticle,
  salesNavigatorArticle,
  buyingSignalsArticle,
  leexiPricingArticle,
  freeCallAnalysisArticle,
  modjoAlternativesArticle,
  linkedinMessageArticle,
  situationTargetingArticle,
  clientAvatarArticle,
  offerBuildArticle,
  callToolsArticle,
];

export const CATEGORY_IDS_WITH_ARTICLES = new Set(
  BLOG_ARTICLES.map((article) => article.categoryId),
);

export function findArticleBySlug(lang: string, slug: string): BlogArticle | undefined {
  return BLOG_ARTICLES.find((article) => article.slug[lang] === slug);
}

export function getArticleLocale(article: BlogArticle, lang: string): BlogArticleLocale {
  return article.locales[lang] ?? article.locales.fr;
}

// Same category first, then the rest, so the suggestion stays close to what was
// just read without ever leaving the reader on a dead end.
export function getRelatedArticles(article: BlogArticle, count: number): BlogArticle[] {
  const others = BLOG_ARTICLES.filter((item) => item.key !== article.key);
  const sameCategory = others.filter((item) => item.categoryId === article.categoryId);
  const rest = others.filter((item) => item.categoryId !== article.categoryId);

  return [...sameCategory, ...rest].slice(0, count);
}
